// extracted by mini-css-extract-plugin
export var activityContainer = "_j5-0";
export var typingIndicatorContainer = "_j5-1";
export var typingIndicatorDot = "_j5-2";
export var wave = "_j5-3";